export default "__VITE_ASSET__CJgjsnBS__"